import type { CategoryItem } from "@/types";

export const categories: CategoryItem[] = [
  {
    key: "hot-blood",
    name: "热血",
    desc: "燃到爆的战斗与成长，热血少年的逆袭之路。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20a%20clenched%20fist%20surrounded%20by%20fiery%20energy%20sparks%20and%20light%20streaks%2C%20energetic%20bold%20composition%2C%20cel-shaded%20digital%20art%2C%20saturated%20warm%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-hotblood-01&orientation=squarish",
    count: 186,
  },
  {
    key: "healing",
    name: "治愈",
    desc: "温柔日常与暖心动漫，治愈每一个疲惫的灵魂。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20soft%20glowing%20flowers%20and%20a%20cozy%20warm%20lamp%20light%20in%20a%20peaceful%20room%2C%20gentle%20comforting%20mood%2C%20cel-shaded%20digital%20art%2C%20saturated%20warm%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-healing-01&orientation=squarish",
    count: 214,
  },
  {
    key: "adventure",
    name: "冒险",
    desc: "踏上未知旅途，展开波澜壮阔的冒险物语。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20a%20compass%20and%20an%20old%20map%20with%20distant%20mountains%20and%20open%20sky%2C%20sense%20of%20grand%20journey%2C%20cel-shaded%20digital%20art%2C%20saturated%20warm%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-adventure-01&orientation=squarish",
    count: 253,
  },
  {
    key: "scifi",
    name: "科幻",
    desc: "未来世界与浩瀚星空，探索科技的无限想象。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20futuristic%20neon%20circuitry%20and%20a%20distant%20spaceship%20in%20space%2C%20sci-fi%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-scifi-01&orientation=squarish",
    count: 178,
  },
  {
    key: "romance",
    name: "恋爱",
    desc: "心动与怦然的青春，藏不住的喜欢与悸动。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20two%20hearts%20and%20drifting%20cherry%20blossom%20petals%20in%20soft%20pink%20light%2C%20romantic%20sweet%20mood%2C%20cel-shaded%20digital%20art%2C%20saturated%20warm%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-romance-01&orientation=squarish",
    count: 231,
  },
  {
    key: "suspense",
    name: "悬疑",
    desc: "迷雾重重的推理，抽丝剥茧揭开真相。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20a%20magnifying%20glass%20over%20a%20misty%20mysterious%20dark%20scene%20with%20glowing%20clues%2C%20intense%20intrigue%2C%20cel-shaded%20digital%20art%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-suspense-01&orientation=squarish",
    count: 142,
  },
  {
    key: "campus",
    name: "校园",
    desc: "青春校园与成长物语，那年的阳光与蝉鸣。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20a%20school%20classroom%20with%20warm%20afternoon%20sunlight%20through%20windows%20and%20a%20light%20summer%20breeze%2C%20nostalgic%20youth%20mood%2C%20cel-shaded%20digital%20art%2C%20saturated%20warm%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-campus-01&orientation=squarish",
    count: 205,
  },
  {
    key: "fantasy",
    name: "奇幻",
    desc: "魔法与传说交织的异世界，翱翔于幻想之上。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20themed%20illustration%20of%20a%20glowing%20magic%20crystal%20with%20floating%20runes%20and%20a%20mystical%20castle%20silhouette%20in%20the%20distance%2C%20enchanting%20fantasy%20mood%2C%20cel-shaded%20digital%20art%2C%20saturated%20colors%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=400&height=400&seq=cat-fantasy-01&orientation=squarish",
    count: 268,
  },
];